<template>
  <div class="help">
    <h3 id="help-header">ヘルプ</h3>
    <p class="help-questions">Ｑ：マイ酒リストに登録したお酒を削除したい</p>
    <p>Ａ：Androidの場合、右フリックで削除ボタンが表示されます。iOSの場合、長押しで削除ボタンが表示されます。</p>
    <p class="help-questions">Ｑ：みんなのライブに登録したお酒を削除したい</p>
    <p>Ａ：マイ酒リストで削除したい銘柄を選択、編集モードにして、ライブ投稿をOFFにしてから保存してください。</p>
    <p class="help-questions">Ｑ：位置が記録されません</p>
    <p>Ａ：Androidの場合、設定画面でGPSや無線ネットワークでの位置検出をONにしてください。iOSの場合、[設定アプリ]-[プライバシ]-[位置情報サービス]でSakenoteの設定をONに変更してください。</p>
    <p class="help-questions">Ｑ：登録したいお酒がヒットしません</p>
    <p>Ａ：<a href="https://docs.google.com/forms/d/e/1FAIpQLScGxl8fC914BAcPpIlt4ceQjxUvuRdTer7TA3XNyrsDPIKL2w/viewform?formkey=dFZMYXc3SHJiT2dIeTlKT2w3Y3lYeWc6MQ#gid=0">Sakenote銘柄登録リクエスト</a>にお知らせ下さい！登録いたします。</p>
    <p class="help-questions">Ｑ：お酒の情報が間違っている</p>
    <p>Ａ：<a href="mailto:info@sakenote.com">info@sakenote.com</a>までお知らせください！次回アップデートで修正します。</p>
    <p class="help-questions">Ｑ：メールアドレスを登録しましたが、登録キーが返送されてきません</p>
    <p>Ａ：Sakenoteから登録キーを送信した際、メールが受信拒否されているか、返信先に指定されたメールアドレスが間違っている可能性があります。メールの設定確認後、再度ユーザー登録をしてください。</p>
  </div>
</template>
<script>
export default {
  name: 'help'
}
</script>
<style scoped>
.help {
  margin: 0% 8%;
  font-size: 16px;
}
#help-header {
  text-align: center;
}
.help-questions {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Help.vue